import React from "react";
import "./Image_Deco.css";
export default function Image_Deco () {
  return (
    <>
    <section>
      <div id="img_deco"></div>
    </section>
    </>
  );
}
